import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/** Alinhado ao breakpoint `md` do Tailwind (min-width: 768px). */
export const MOBILE_BREAKPOINT_PX = 768

const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT_PX - 1}px)`

export function readIsMobileViewport(): boolean {
  if (typeof window === 'undefined') return false
  return window.matchMedia(MOBILE_MEDIA_QUERY).matches
}

interface UIState {
  sidebarOpen: boolean
  sidebarCollapsed: boolean
  isMobileOpen: boolean

  // Detecta mobile (< 768px) — sincronizado via syncMobileViewport
  isMobile: boolean

  // Actions
  toggleSidebar: () => void
  setSidebarOpen: (open: boolean) => void
  toggleSidebarCollapsed: () => void
  setSidebarCollapsed: (collapsed: boolean) => void
  toggleMobileMenu: () => void
  closeMobileMenu: () => void
  setIsMobile: (v: boolean) => void
  /** Atualiza isMobile a partir da largura atual; fecha drawer se voltar ao desktop. */
  syncMobileViewport: () => void
}

export const useUIStore = create<UIState>()(
  persist(
    (set, get) => ({
      sidebarOpen: true,
      sidebarCollapsed: false,
      isMobileOpen: false,
      isMobile: readIsMobileViewport(),

      toggleSidebar: () =>
        set((state) => ({ sidebarOpen: !state.sidebarOpen })),

      setSidebarOpen: (open) => set({ sidebarOpen: open }),

      toggleSidebarCollapsed: () =>
        set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),

      setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),

      toggleMobileMenu: () =>
        set((state) => ({ isMobileOpen: !state.isMobileOpen })),

      closeMobileMenu: () => set({ isMobileOpen: false }),

      setIsMobile: (v) => set({ isMobile: v }),

      syncMobileViewport: () => {
        const next = readIsMobileViewport()
        const { isMobile, isMobileOpen } = get()
        if (next === isMobile && !(isMobileOpen && !next)) return
        set({
          isMobile: next,
          isMobileOpen: next ? isMobileOpen : false,
        })
      },
    }),
    {
      name: 'crm-ui',
      partialize: (state) => ({
        sidebarCollapsed: state.sidebarCollapsed,
      }),
    }
  )
)
